import { DispatchLeg } from '@api/Trinium/Endpoints/Dispatch/types';
import { defaultSortComparator } from '@components/DataGrid/types';
import { applyColumnQuickFilter, caseInsensitiveIncludes } from '../columns';
import RenderHeader from '@components/DataGrid/RenderHeader';
import RenderCell from '@components/DataGrid/RenderCell';
import { GridColDefExtended } from '@mui/x-data-grid-pro';

import styles from '../../RenderCell.module.css';

const traceLastFreeDateDefinition: GridColDefExtended<DispatchLeg> = {
	field: 'Trc LFD',
	minWidth: 130,
	width: 150,
	headerName: 'Trc LFD',
	renderHeader: () => <RenderHeader primaryText='Trc LFD' />,
	renderCell: ({ row }) => (
		<RenderCell
			primarySlot={
				row.trcLFD && (
					<span
						className={styles.bold}
						title={row.trcLFD}
					>
						{row.trcLFD}
					</span>
				)
			}
		/>
	),
	disableReorder: true,
	getApplyQuickFilterFn: (value: string) => {
		return (_, row): boolean =>
			applyColumnQuickFilter(value, row, (value: string, row: DispatchLeg) => {
				const { trcLFD } = row;
				return caseInsensitiveIncludes(value, [trcLFD]);
			});
	},
	valueGetter: (_, row: DispatchLeg) => row.trcLFD ?? '',
	sortable: true,
	sortComparator: defaultSortComparator
};

export default traceLastFreeDateDefinition;
